'use strict';

    angular.module('amexReconciliationApp')
      .service('BtaAccountsRepository', function ($resource) {
        var self = this;

       var btaSummariesResource = $resource('/api/v1/authenticatedUser/btaSummary', {}, {
             getBtas: { method: 'get', isArray: true }
           });

       self.get = function () {
              return btaSummariesResource.getBtas().$promise;
            };

           var statementsResource = $resource('/api/v1/statements', {}, {
                 getStatements: { method: 'get', isArray: true }
               });
      });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/BtaAccountsRepository.js
// module id = 604
// module chunks = 0